const FIRST_RESTRO_API = 'https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.65420&lng=77.23730&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING#'

const CLOUDINARY_URL = 'https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/'

const RESTAURANT_MENU_API = 'https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.65420&lng=77.23730&restaurantId='

const OFFERS_LOGO_BASE_URL = 'https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_96,h_96/'

const APP_LOGO_URL = 'https://res.cloudinary.com/zbcopdpd/image/upload/v1787175786/app_icon_tjtu6c.png'

export {
    FIRST_RESTRO_API,
    CLOUDINARY_URL,
    RESTAURANT_MENU_API,
    OFFERS_LOGO_BASE_URL,
    APP_LOGO_URL
}